import React from "react";
import {logger} from "@/utils";

class ErrorBoundary extends React.Component{
    constructor(props) {
        super(props);
        this.state = {hasError:false};
    }

    static getDerivedStateFromError(error){
        console.error('getDerivedStateFromError')
        return {hasError:true};
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // if (import.meta.env.DEV){
        //     throw Error;
        // }
        console.error('ErrorBoundary caught an error', error, errorInfo);
        logger('ErrorBoundary caught an error');
        logger(error);
        logger(errorInfo);
    }

    render() {
        if (this.state.hasError){
            //
        }
        return this.props.children;
    }
}

export default ErrorBoundary